import { Box } from "@mui/material";
import DOMPurify from "dompurify";

interface Props {
  content: string;
}

function HTMLRenderer(props: Props) {
  const { content } = props;

  return (
    <Box
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(content, {
          FORBID_TAGS: ["script", "style"],
          ADD_TAGS: ["iframe"],
          ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling"]
        })
      }}
    />
  );
}

export default HTMLRenderer;
